import { createContext } from 'react';

export const RecordingsSearchContext = createContext(null);
